import { CountryUpdatePage } from "@/features/geolocation/page/CountryUpdate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/country/$id/update")({
  component: CountryUpdatePage,
});
